document.addEventListener("DOMContentLoaded", () => {
  const playButtons = document.querySelectorAll(".videos-grid__play-button");
  const popups = document.querySelectorAll(".videos-grid__popup");

  playButtons.forEach((button, index) => {
    const popup = popups[index];
    const videoContainer = popup.querySelector(".videos-grid__main-video");
    const videoWrapper = popup.querySelector(".videos-grid__main-video-wrapper");
    const videoId = videoContainer.getAttribute("data-vimeo-id");
    let player;
    let iframe;

    const getVideoSize = async (videoId) => {
      try {
        const response = await fetch(`https://vimeo.com/api/oembed.json?url=https://vimeo.com/${videoId}`);
        const data = await response.json();
        return { width: data.width, height: data.height };
      } catch (error) {
        console.error(`${videoId}:`, error);
        return { width: 640, height: 360 }; 
      }
    };

    const resizeVideo = async () => {
      const { width: videoWidth, height: videoHeight } = await getVideoSize(videoId);
      const containerWidth = videoWrapper.clientWidth;
      const containerHeight = window.innerHeight * 0.88; 

      const videoRatio = videoWidth / videoHeight;
      const containerRatio = containerWidth / containerHeight;

      let newWidth, newHeight;

      if (videoRatio > containerRatio) {
        newWidth = containerWidth;
        newHeight = newWidth / videoRatio;
      } else {
        newHeight = containerHeight;
        newWidth = newHeight * videoRatio;
      }

      videoContainer.style.width = `${newWidth}px`;
      videoContainer.style.height = `${newHeight}px`;

      if (iframe) {
        iframe.width = newWidth;
        iframe.height = newHeight;
      }
    };

    const initializePlayer = async () => {
      if (!player) {
        player = new Vimeo.Player(videoContainer, { id: videoId });
        iframe = await player.element;
        player.on("loaded", resizeVideo);
      }
    };

    const closePopup = () => {
      popup.classList.remove("active");
      if (player) {
        player.pause();
      }
    };

    button.addEventListener("click", async () => {
      await initializePlayer(); 
      videoContainer.style.opacity = "0"; 

      await resizeVideo(); 
      popup.classList.add("active"); 

      setTimeout(() => {
        videoContainer.style.opacity = "1"; 
      }, 500); 

      player.ready().then(() => player.play());
    });

    window.addEventListener("resize", resizeVideo);

    const closeButton = popup.querySelector(".videos-grid__popup-close");
    closeButton.addEventListener("click", closePopup);

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && popup.classList.contains("active")) {
        closePopup();
      }
    });
  });
});

document.addEventListener("DOMContentLoaded", () => {
  const swiperContainer = document.querySelector(".videos-grid__swiper");

  function initializeSwiper() {
    new Swiper(".videos-grid__swiper", {
      spaceBetween: 20,
      slidesPerView: 2.3,
      watchOverflow: true,
      breakpoints: {
        476: {
          slidesPerView: 2.3,
        },
        650: {
          slidesPerView: 3.3,
        },
        990: {
          slidesPerView: 4.3,
        },
        1100: {
          spaceBetween: 30,
          slidesPerView: 5,
        }
      }
    });
  }

  if (swiperContainer) {
    initializeSwiper();
  }
});

document.addEventListener("DOMContentLoaded", () => {
  const videosGrid = document.querySelector(".videos-grid__content");
  if (!videosGrid) return;

  const videoContainers = videosGrid.querySelectorAll(".video-container");
  const players = [];
  let isSectionVisible = false;
  let currentVideoIndex = 0;
  let isPlaying = false;

  videoContainers.forEach((container) => {
    const player = new Vimeo.Player(container, {
      id: container.dataset.vimeoId,
      muted: true,
      autoplay: false,
      playsinline: container.dataset.vimeoPlaysinline === "true",
      controls: container.dataset.vimeoControls === "false",
    });

    players.push(player);
  });

  function playVideo(index) {
    if (!isSectionVisible || index < 0 || index >= players.length || isPlaying) return;
    const player = players[index];
    isPlaying = true;

    player.play()
      .then(() => {
        currentVideoIndex = index;
        console.log(`Playing video ${index + 1}`);
      })
      .catch((err) => {
        console.error("Error playing video:", err);
      })
      .finally(() => {
        isPlaying = false;
      });
  }

  function pauseVideo(index) {
    if (index < 0 || index >= players.length || isPlaying) return;
    const player = players[index];
    player.pause()
      .then(() => {
        console.log(`Paused video ${index + 1}`);
      })
      .catch((err) => console.error("Pause error:", err));
  }

  players.forEach((player, index) => {
    player.on("ended", () => {
      const playerContainer = videoContainers[index];
      player.setCurrentTime(0).catch((err) => console.error("Set time error:", err));
      const nextIndex = (currentVideoIndex + 1) % players.length;
      playVideo(nextIndex);
    });
  });

  const observerOptions = {
    root: null,
    threshold: 0.4,
  };

  const observer = new IntersectionObserver((entries) => {
    entries.forEach((entry) => {
      if (entry.target === videosGrid) {
        if (entry.isIntersecting) {
          isSectionVisible = true;
          playVideo(currentVideoIndex);
        } else {
          isSectionVisible = false;
          pauseVideo(currentVideoIndex);
        }
      }
    });
  }, observerOptions);

  observer.observe(videosGrid);

  const rect = videosGrid.getBoundingClientRect();
  if (rect.top >= 0 && rect.bottom <= window.innerHeight * 0.7) {
    isSectionVisible = true;
    playVideo(currentVideoIndex);
  }
});